const productTitle = document.querySelector(".product-title").textContent
const fwcImg = document.querySelector(".fwc-img")

if (productTitle.includes("Grey")) {
  fwcImg.src="https://cdn.shopify.com/s/files/1/0555/4271/0370/files/4-7-22_Didit_Hampton_Day_24438_-_Grey_with_Fireplace.png?v=1650910380";
  fwcImg.alt="Round grey glass table top with navy blue couch on one side and lit fireplace on the other side";
} else if (productTitle.includes("Bronze")) {
  fwcImg.src="https://cdn.shopify.com/s/files/1/0555/4271/0370/files/Round-bronze-glass-table-with-glass-base-next-to-wicker-chair.jpg?v=1651612328";
  fwcImg.alt="Round bronze glass table with glass base next to wicker chair";
} else if (productTitle.includes("Iron")) {
  fwcImg.src="https://cdn.shopify.com/s/files/1/0555/4271/0370/files/low-iron-glass-gem-compare2.jpg?v=1651008568";
  fwcImg.alt="Piece of clear glass with green tint next to a piece of clear low iron glass with slight green tint";
} else {
  fwcImg.src="https://cdn.shopify.com/s/files/1/0555/4271/0370/files/4-6-22_Didit_Hampton_Day_14258_-_Clear.jpg?v=1650992328";
  fwcImg.alt="Round clear glass table on cylindrical glass base with bevel edges next to white couch";
}


function handleBuyNowClick() {
  // Logic to add the product to the cart and redirect to checkout
  let formElement = document.querySelector('[data-product-form]');
  let formData = new FormData(formElement);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    window.location.href = '/checkout';
  })
  // .catch(error => console.log('Error:', error));
}